import { createUseStyles } from "react-jss";

export const useStyles = createUseStyles({
    errorPageBody: {
        position: "relative",
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        textAlign: "center",
        zIndex: 2,
        "& .errorPageBg": {
            fontSize: "40vw",
            lineHeight: 0,
            fontWeight: "bold",
            position: "fixed",
            color: "rgb(255, 0, 0, 0.05)",
            left: "50%",
            top: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: "1 !important",
        },
        "& .errorPageInfo": {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            "& p": {
                fontSize: "24px",
                fontWeight: "bold",
                color: "#333",
                margin: "30px 0 0",
                "& span": {
                    color: "red",
                    fontSize: "40px",
                },
            },
            "& a": {
                padding: "8.5px 39.5px",
                borderRadius: "5px",
                backgroundColor: "#333",
                color: "#fff",
                fontSize: "16px",
                fontWeight: 600,
                lineHeight: "normal",
                border: "2px solid transparent",
                transition: "0.3s all ease-in-out",
                cursor: "pointer",
                marginTop: "30px",
            },
            "& span": {
                color: "#333",
                fontSize: "18px",
                marginTop: "10px",
            },
            "& .logo": { width: "250px", marginBottom: "60px" },
            "& .catGif": {
                width: "135px",
                position: "relative",
                borderRadius: "50%",
                border: "2px solid #333",
            },
        },
    },
});
